const getElementDimensions = element => {
  if (!element.getBoundingClientRect) {
    return {}
  }

  return element.getBoundingClientRect()
}

export default getElementDimensions
